import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PersonalDataForm.html?raw';
import on from 'dojo/on';
import "../PersonalDataForm/PersonalDataFormTypes";

import _StatefulBase from '../../moreCore/UI/_StatefulBase/_StatefulBase';
import DateInput from '../../moreCore/UI/DateInput/DateInput';
import '../../moreCore/UI/DateInput/DateInput';
import Edit from '../../moreCore/UI/Edit/Edit';
import '../../moreCore/UI/Edit/Edit';
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import '../../moreCore/UI/SelectBox/SelectBox';
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';
import '../../moreCore/UI/RadioGroup/RadioGroup';
import HintBox from '../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../moreCore/UI/EntityBased/HintBox/HintBox';
import PhoneInput from '../../moreCore/UI/PhoneInput/PhoneInput';
import '../../moreCore/UI/PhoneInput/PhoneInput';
import FileUpload from '../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import '../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import '../../moreCore/UI/GenericDialog/GenericDialog';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import '../../moreCore/UI/CheckBox/CheckBox';
import { ExtraHelpers } from "../../more/Helpers";

class PersonalDataForm extends compose(_WidgetBaseSP) {
    templateString: any = template;


    // ContainerNodes for Inputs ------------------------START

    RadioGroup_language: HTMLElement;
    Edit_name: HTMLElement;
    Edit_surname: HTMLElement;
    RadioGroup_gender: HTMLElement;
    DateInput_birthDate: HTMLElement;
    SelectBox_birthCountry: HTMLElement;
    HintBox_birthPlace: HTMLElement;
    SelectBox_citizenship: HTMLElement;
    SelectBox_country_residence: HTMLElement;
    SelectBox_province_residence: HTMLElement;
    Edit_ZIP_residence: HTMLElement;
    Edit_city_residence: HTMLElement;
    Edit_streetNumber_residence: HTMLElement;
    RadioGroup_domicileAddress_isResidenceAddress: HTMLElement;
    SelectBox_country_domicile: HTMLElement;
    SelectBox_province_domicile: HTMLElement;
    Edit_ZIP_domicile: HTMLElement;
    Edit_city_domicile: HTMLElement;
    Edit_streetNumber_domicile: HTMLElement;
    phoneInput_phone: HTMLElement;
    Edit_email: HTMLElement;
    RadioGroup_italianFiscalCode: HTMLElement;
    Edit_italianFiscalCode: HTMLElement;
    Edit_accountHolder_EU: HTMLElement;
    Edit_IBAN: HTMLElement;
    Edit_accountHolder_Foreign: HTMLElement;
    Edit_bankName: HTMLElement;
    bankAddress_node: HTMLElement;
    Edit_BankAccNumber: HTMLElement;
    Edit_BIC_SWIFT: HTMLElement;
    Edit_RoutingNumber: HTMLElement;
    RadioGroup_socialSecurity_Italians: HTMLElement;
    RadioGroup_VAT_Italians: HTMLElement;
    Edit_VATNumber_Italians: HTMLElement;
    RadioGroup_socialSecurity_Foreigners: HTMLElement;
    Edit_fiscalTaxCode: HTMLElement;
    Edit_VATNumber_Foreigners: HTMLElement;
    RadioGroup_residencePermit: HTMLElement;
    Edit_number_residencePermit: HTMLElement;
    DateInput_validUntil_residencePermit: HTMLElement;
    Edit_reasonOfStay_residencePermit: HTMLElement;
    Edit_issuedBy_residencePermit: HTMLElement;
    RadioGroup_Visa: HTMLElement;
    DateInput_validPeriod_Visa_from: HTMLElement;
    DateInput_validPeriod_Visa_until: HTMLElement;
    DateInput_enteringItaly: HTMLElement;
    DateInput_leavingItaly: HTMLElement;
    Edit_issuedBy_Visa: HTMLElement;
    FileUpload_documents: HTMLElement;
    CheckBox_privacy: HTMLElement;
    RadioGroup_hasUidNumber_Foreigners: HTMLElement;


    // ContainerNodes for Inputs ------------------------END

    // If nodes (optional show/hide)---------------------STÀRT

    DataForm: HTMLElement;
    languageSelection: HTMLElement;
    selectLangButton: HTMLButtonElement;
    bank_details: HTMLElement;
    countryNotSpecifiedMsg: HTMLElement;
    CitizenshipNotSpecifiedMsg: HTMLElement;
    FileUpload_Note_notMandatory_Foreign: HTMLElement;
    reminder_socialSec: HTMLElement;
    phoneInput_mobile: HTMLElement;

    //  Is the domicile address the same as the residence address? – show if no
    ifDifferentAddress: HTMLElement;

    // Do you have an Italian fiscal code? - show if yes
    ifItalianFiscalCode: HTMLElement;

    // show if country of residenci is in EU
    ifEUResident: HTMLElement;

    //show if country of residenci is not in EU
    ifNotEuResident: HTMLElement;

    // show for italian citizens only
    ifItalianCitizen: HTMLElement;

    // show for italians only && if ( RadioGroup_VAT_Italians value == yes )
    ifVATNumberItalian: HTMLElement;

    // show for not italian citizens only
    ifNotItalianCitizen: HTMLElement;

    // show for not europeans only
    ifNotEuropeanCitizen: HTMLElement;

    // show for not europeans only && if (RadioGroup_residencePermit value == yes)
    ifHaveResidencePermit: HTMLElement;

    // show for not europeans only && if (RadioGroup_Visa value == yes)
    ifHaveVisa: HTMLElement;
    // If nodes (optional show/hide)---------------------END

    // Inputs ----------------------------------------START
    firstName: MdsLax<InstanceType<typeof Edit>>;
    surname: MdsLax<InstanceType<typeof Edit>>;
    streetNumber_residence: MdsLax<InstanceType<typeof Edit>>;
    streetNumber_domicile: MdsLax<InstanceType<typeof Edit>>;
    email: MdsLax<InstanceType<typeof Edit>>;
    italianFiscalCode: MdsLax<InstanceType<typeof Edit>>;
    accountHolder_EU: MdsLax<InstanceType<typeof Edit>>;
    IBAN: MdsLax<InstanceType<typeof Edit>>;
    accountHolder_Foreign: MdsLax<InstanceType<typeof Edit>>;
    bankName: MdsLax<InstanceType<typeof Edit>>;
    bankAccNumber: MdsLax<InstanceType<typeof Edit>>;
    BIC_SWIFT: MdsLax<InstanceType<typeof Edit>>;
    routingNumber: MdsLax<InstanceType<typeof Edit>>;
    VATNumber_Italians: MdsLax<InstanceType<typeof Edit>>;
    fiscalTaxCode: MdsLax<InstanceType<typeof Edit>>;
    VATNumber_Foreigners: MdsLax<InstanceType<typeof Edit>>;
    number_residencePermit: MdsLax<InstanceType<typeof Edit>>;
    reasonOfStay_residencePermit: MdsLax<InstanceType<typeof Edit>>;
    issuedBy_residencePermit: MdsLax<InstanceType<typeof Edit>>;
    issuedBy_Visa: MdsLax<InstanceType<typeof Edit>>;
    bankAddress: MdsLax<InstanceType<typeof Edit>>;

    birthCountry: MdsLax<InstanceType<typeof SelectBox>>;
    citizenship: MdsLax<InstanceType<typeof SelectBox>>;
    country_residence: MdsLax<InstanceType<typeof SelectBox>>;
    country_domicile: MdsLax<InstanceType<typeof SelectBox>>;


    language: MdsLax<InstanceType<typeof RadioGroup>>;
    gender: MdsLax<InstanceType<typeof RadioGroup>>;
    domicileAddress_isResidenceAddress: MdsLax<InstanceType<typeof RadioGroup>>;
    hasItalianFiscalCode: MdsLax<InstanceType<typeof RadioGroup>>;
    socialSecurity_Italians: MdsLax<InstanceType<typeof RadioGroup>>;
    hasVAT_Italians: MdsLax<InstanceType<typeof RadioGroup>>;
    socialSecurityExemption_Foreigners: MdsLax<InstanceType<typeof RadioGroup>>;
    hasResidencePermit: MdsLax<InstanceType<typeof RadioGroup>>;
    hasVisa: MdsLax<InstanceType<typeof RadioGroup>>;
    hasUidNumber_Foreigners: MdsLax<InstanceType<typeof RadioGroup>>;

    birthDate: MdsLax<InstanceType<typeof DateInput>>;
    validUntil_residencePermit: MdsLax<InstanceType<typeof DateInput>>;
    validPeriod_Visa_from: MdsLax<InstanceType<typeof DateInput>>;
    validPeriod_Visa_until: MdsLax<InstanceType<typeof DateInput>>;
    enteringItaly: MdsLax<InstanceType<typeof DateInput>>;
    leavingItaly: MdsLax<InstanceType<typeof DateInput>>;


    birthPlace: MdsLax<InstanceType<typeof Edit>>;
    province_residence: MdsLax<InstanceType<typeof Edit>>;
    ZIP_residence: MdsLax<InstanceType<typeof HintBox>>;
    city_residence: MdsLax<InstanceType<typeof HintBox>>;
    province_domicile: MdsLax<InstanceType<typeof Edit>>;
    ZIP_domicile: MdsLax<InstanceType<typeof HintBox>>;
    city_domicile: MdsLax<InstanceType<typeof HintBox>>;

    phone: PhoneInput;
    mobile: PhoneInput;
    documents_upload: MdsLax<InstanceType<typeof FileUpload>>;

    privacyCheckBox: MdsLax<InstanceType<typeof CheckBox>>;

    dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    // Inputs ----------------------------------------- END

    // Properties -------------------------------------START
    selectedLanguage: string;
    personName: string;
    personSurname: string;
    defaultCountrySelect: string;
    privacyChecked: boolean = false;

    isItalianCitizen: boolean;
    isEuCitizen: boolean;

    isEuResident: boolean;

    __request: dojo.request.Promise<any>;
    controllerUrl: string = "PersonalData/SaveFormData";

    beforeOnloadEventFunction: any = function (event) {
        event.returnValue = "";
    };

    AllCountriesData: Array<Country>;
    protected topCountries: Array<Country> = [];
    EU_Countries: string[] = ["al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
        "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
        "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
        "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua"];

    preferredCountries: string[] = [];

    allValues: object = {};

    // um daten auf Vollzähligkeit zu prüfen
    mandataoryFields: Array<string> = ['language', 'firstName', 'surname', 'gender', 'birthDate', 'birthCountry', 'birthPlace', 'citizenship', 'country_residence', 'ZIP_residence', 'city_residence', 'streetNumber_residence', 'phone', 'mobile', 'email', 'hasItalianFiscalCode', 'domicileAddress_isResidenceAddress'];
    fields_ItalianCitizen: Array<string> = ['socialSecurity_Italians', 'hasVAT_Italians', 'italianFiscalCode'];
    fields_notItalianCitizen: Array<string> = ['socialSecurityExemption_Foreigners', 'fiscalTaxCode', 'hasUidNumber_Foreigners'];
    fields_notEuCitizen: Array<string> = ['hasResidencePermit', 'hasVisa'];
    fields_hasResidencePermit: Array<string> = ['number_residencePermit', 'validUntil_residencePermit', 'reasonOfStay_residencePermit', 'issuedBy_residencePermit'];
    fields_hasVisa: Array<string> = ['validPeriod_Visa_from', 'validPeriod_Visa_until', 'enteringItaly', 'leavingItaly', 'issuedBy_Visa'];
    fields_domicile_residence_address: Array<string> = ['country_domicile', 'ZIP_domicile', 'city_domicile', 'streetNumber_domicile'];

    caseEditingFields: Array<string> = ['firstName', 'surname', 'city_residence', 'city_domicile', 'birthPlace', 'province_domicile', 'province_residence', 'accountHolder_Foreign', 'accountHolder_EU'];
    // Properties -------------------------------------END

    // Events ----------------------------------------- START

    _onChangeSelectLang(evt?: Event): void {

        this.changeLanguage();
    }


    _onClick_Continue_Button(): void {

        window.addEventListener("beforeunload", this.beforeOnloadEventFunction);

        this.UiModder.domClass.remove(this.DataForm, "w3-hide");
        this.UiModder.domClass.add(this.languageSelection, "w3-hide");
        this.UiModder.domClass.remove(this.selectLangButton, "w3-hide");

        this._showBankDetails();
    }

    _onClick_selectLang_Button(): void {
        this.UiModder.domClass.remove(this.languageSelection, "w3-hide");
        this.UiModder.domClass.add(this.selectLangButton, "w3-hide");
    }

    // checks if residence country is specified, if not - shows message "specify country first", onValueChange event in the countryOfResidence input closes the messafe and the bank details block
    _showBankDetails(): void {
        // Acccountholder BancAccount - display name & surname values || null
        let accHolder: string;

        (this.firstName.getValue() && this.surname.getValue()) ? accHolder = `${this.firstName.getValue()} ${this.surname.getValue()}` : accHolder = null;

        // Dom Nodes
        //this.UiModder.domClass.contains(this.bank_details, "w3-hide") ? this.UiModder.domClass.remove(this.bank_details, "w3-hide") : this.UiModder.domClass.add(this.bank_details, "w3-hide");

        if (typeof this.isEuResident == "undefined") {
            this.UiModder.domClass.remove(this.countryNotSpecifiedMsg, "w3-hide");
            this.UiModder.domClass.add(this.ifEUResident, "w3-hide");
        } else if (this.isEuResident === false) {
            this.accountHolder_EU.setValue(null);
            !this.accountHolder_Foreign.getValue() && this.accountHolder_Foreign.setValue(accHolder); // set value wenn keine vorhanden
            this.UiModder.domClass.add(this.ifEUResident, "w3-hide");
            this.UiModder.domClass.remove(this.ifNotEuResident, "w3-hide");
        } else {
            !this.accountHolder_EU.getValue() && this.accountHolder_EU.setValue(accHolder); // set value wenn keine vorhanden
            this.accountHolder_Foreign.setValue(null);
            // Styling
            this.animateInput(this.accountHolder_EU.inputNode);
            this.animateInput(this.IBAN.inputNode);
            this.UiModder.domClass.remove(this.ifEUResident, "w3-hide");
            this.UiModder.domClass.add(this.ifNotEuResident, "w3-hide");
        }
    }

    _onValueChange_firstName(): void {
        this.addValue(this.firstName);
        this._showBankDetails()
    }

    _onValueChange_surname(): void {
        this.addValue(this.surname);
        this._showBankDetails()
    }

    _onValueChange_gender(): void {
        this.addValue(this.gender);

    }

    _onValueChange_birthDate(): void {
        this.addDateValue(this.birthDate);
    }

    _onValueChange_birthCountry(): void {
        //if (this.birthCountry.getValue()) {
        //    this.birthPlace.setAdditionalRequestParams('country', this.birthCountry.getValue());

        //}

        this.addValue(this.birthCountry);

        this.showProvinceInput(this.birthPlace);

    }

    _onValueChange_birthPlace(): void {
        this.addValue(this.birthPlace);

    }

    _onBirthPlaceSearchError(error: any) {
        console.error(error);
    }

    //sets booleans   this.isItalianCitizen, this.isEuCitizen, modifies optional show/hide in the dom
    _onValueChange_citizenship(): void {
        this.addValue(this.citizenship);


        let iso2Value: string = this.citizenship.getValue()
        this.isItalianCitizen = iso2Value === "it";
        this.isEuCitizen = this.EU_Countries.indexOf(iso2Value) < 0 ? false : true;


        // DOM manipulation
        this.UiModder.domClass.add(this.CitizenshipNotSpecifiedMsg, "w3-hide");

        if (this.isItalianCitizen) {
            // optional form inputs
            this.UiModder.domClass.remove(this.ifItalianCitizen, "w3-hide");
            this.socialSecurity_Italians.setMandatory(true);
            this.hasVAT_Italians.setMandatory(true);

            // Verbesserung feedback 14.01.2021 --start
            this.UiModder.domClass.add(this.RadioGroup_italianFiscalCode, "w3-hide");
            this.hasItalianFiscalCode.setMandatory(false);

            this.UiModder.domClass.remove(this.ifItalianFiscalCode, "w3-hide");
            this.italianFiscalCode.setMandatory(true);
            //Verbesserung feedback 14.01.2021 -- end

            this.UiModder.domClass.add(this.ifNotItalianCitizen, "w3-hide");
            this.socialSecurityExemption_Foreigners.setMandatory(false);
            this.fiscalTaxCode.setMandatory(false);

            this.hasUidNumber_Foreigners.setMandatory(false);

            this.UiModder.domClass.add(this.ifNotEuropeanCitizen, "w3-hide");
            this.hasResidencePermit.setMandatory(false);
            this.hasVisa.setMandatory(false);

            // FileUpload Notes
            this.UiModder.domClass.add(this.FileUpload_Note_notMandatory_Foreign, "w3-hide");
        } else {
            // optional form inputs

            //Verbesserung feedback 14.01.2021 --start
            this.UiModder.domClass.remove(this.RadioGroup_italianFiscalCode, "w3-hide");
            this.hasItalianFiscalCode.setMandatory(true);

            this.UiModder.domClass.add(this.ifItalianFiscalCode, "w3-hide");
            this.italianFiscalCode.setMandatory(false);
            //Verbesserung feedback 14.01.2021 -- end

            this.UiModder.domClass.remove(this.ifNotItalianCitizen, "w3-hide");
            this.socialSecurityExemption_Foreigners.setMandatory(true);
            this.fiscalTaxCode.setMandatory(true);
            this.hasUidNumber_Foreigners.setMandatory(true);

            this.UiModder.domClass.add(this.ifItalianCitizen, "w3-hide");
            this.socialSecurity_Italians.setMandatory(false);
            this.hasVAT_Italians.setMandatory(false);

            // Styling
            this.animateInput(this.fiscalTaxCode.inputNode);
            this.animateInput(this.VATNumber_Foreigners.inputNode);

            // fileUpload Notes
            this.UiModder.domClass.remove(this.FileUpload_Note_notMandatory_Foreign, "w3-hide");
        }

        if (!this.isEuCitizen) {
            this.UiModder.domClass.add(this.ifItalianCitizen, "w3-hide");
            this.socialSecurity_Italians.setMandatory(false);
            this.hasVAT_Italians.setMandatory(false);

            this.UiModder.domClass.remove(this.ifNotEuropeanCitizen, "w3-hide");
            this.hasResidencePermit.setMandatory(true);
            this.hasVisa.setMandatory(true);
        } else {
            this.UiModder.domClass.add(this.ifNotEuropeanCitizen, "w3-hide");
            this.hasResidencePermit.setMandatory(false);
            this.hasVisa.setMandatory(false);
        }
    }

    _onValueChange_country_residence(): void {
        this.addValue(this.country_residence);

        let iso2Value: string = this.country_residence.getValue();
        this.isEuResident = this.EU_Countries.indexOf(iso2Value) < 0 ? false : true;
        //this.UiModder.domClass.add(this.bank_details, "w3-hide");
        this.UiModder.domClass.add(this.countryNotSpecifiedMsg, "w3-hide");


        this.country_residence.getValue() == 'it' ? this.showProvinceInput(this.province_residence) : this.hideProvinceInput(this.province_residence);
        //this.province_residence.setAdditionalRequestParams('country', this.country_residence.getValue());
        this.ZIP_residence.addAdditionalRequestParameter('country', this.country_residence.getValue());
        this.city_residence.addAdditionalRequestParameter('country', this.country_residence.getValue());

        this._showBankDetails()
    }

    _onValueChange_province_residence(): void {
        this.addValue(this.province_residence);
    }

    _onValueChange_ZIP_residence(): void {
        this.addValue(this.ZIP_residence);

        let zipEntity = this.ZIP_residence.getValue();
        if (zipEntity != null && typeof (zipEntity) == "object") {
            this.city_residence.setValue(zipEntity);

        }
    }

    _onValueChange_city_residence(): void {
        this.addValue(this.city_residence);

        let zipEntity = this.city_residence.getValue();
        if (zipEntity != null && typeof (zipEntity) == "object") {
            this.ZIP_residence.setValue(zipEntity);

        } else {

        }
    }

    _onValueChange_streetNumber_residence(): void {
        this.addValue(this.streetNumber_residence);

    }

    _onChange_domicileAddress_isResidenceAddress(): void {
        this.addValue(this.domicileAddress_isResidenceAddress);


        if (this.domicileAddress_isResidenceAddress.getValue() == "yes") {
            this.UiModder.domClass.add(this.ifDifferentAddress, "w3-hide");
            this.country_domicile.setMandatory(false);
            this.province_domicile.setMandatory(false);
            this.ZIP_domicile.setMandatory(false);
            this.city_domicile.setMandatory(false);
            this.streetNumber_domicile.setMandatory(false);
        } else {
            this.UiModder.domClass.remove(this.ifDifferentAddress, "w3-hide");
            this.country_domicile.setMandatory(true);
            this.ZIP_domicile.setMandatory(true);
            this.city_domicile.setMandatory(true);
            this.streetNumber_domicile.setMandatory(true);
            if (this.country_domicile.getValue() == 'it') {
                this.province_domicile.setMandatory(true);
            }

        }
    }

    _onChange_country_domicile(): void {
        this.addValue(this.country_domicile);

        this.country_domicile.getValue() == 'it' ? this.showProvinceInput(this.province_domicile) : this.hideProvinceInput(this.province_domicile);
        //this.province_domicile.setAdditionalRequestParams('country', this.country_domicile.getValue());
        this.ZIP_domicile.addAdditionalRequestParameter('country', this.country_domicile.getValue());
        this.city_domicile.addAdditionalRequestParameter('country', this.country_domicile.getValue());

    }

    _onChange_province_domicile(): void {
        this.addValue(this.province_domicile);

    }

    _onChange_ZIP_domicile(): void {
        this.addValue(this.ZIP_domicile);

        let zipEntity = this.ZIP_domicile.getValue();
        if (zipEntity != null && typeof (zipEntity) == "object") {
            this.city_domicile.setValue(zipEntity);

        }
    }

    _onChange_city_domicile(): void {
        this.addValue(this.city_domicile);

        let zipEntity = this.city_domicile.getValue();
        if (zipEntity != null && typeof (zipEntity) == "object") {
            this.ZIP_domicile.setValue(zipEntity);

        }
    }

    _onChange_streetNumber_domicile(): void {
        this.addValue(this.streetNumber_domicile);

    }

    _onChange_phone(): void {
        this.addValue(this.phone);
    }

    _onChange_mobile(): void {
        this.addValue(this.mobile);
    }

    _onChange_email(): void {
        this.addValue(this.email);

    }

    _onChange_hasItalianFiscalCode(): void {
        this.addValue(this.hasItalianFiscalCode);


        if (this.hasItalianFiscalCode.getValue() == "no") {

            this.UiModder.domClass.add(this.ifItalianFiscalCode, "w3-hide")
            this.italianFiscalCode.setMandatory(false);
        } else {
            this.animateInput(this.italianFiscalCode.inputNode);
            this.UiModder.domClass.remove(this.ifItalianFiscalCode, "w3-hide");
            this.italianFiscalCode.setMandatory(true);
        }

    }

    _onChange_italianFiscalCode(): void {

        this.addValue(this.italianFiscalCode);

    }

    _onChange_accountHolder_EU(): void {
        this.addValue(this.accountHolder_EU);

    }

    _onChange_IBAN(): void {
        this.addValue(this.IBAN);

    }

    _onChange_accountHolder_Foreign(): void {
        this.addValue(this.accountHolder_Foreign);
    }

    _onChange_bankName(): void {
        this.addValue(this.bankName);

    }

    _onChange_bankAddress(): void {
        this.addValue(this.bankAddress);

    }

    _onChange_bankAccNumber(): void {
        this.addValue(this.bankAccNumber);

    }

    _onChange_BIC_SWIFT(): void {
        this.addValue(this.BIC_SWIFT);

    }

    _onChange_routingNumber(): void {
        this.addValue(this.routingNumber);

    }

    _onChange_socialSecurity_Italians(): void {
        this.addValue(this.socialSecurity_Italians);


    }

    _onChange_VAT_Italians(): void {
        this.addValue(this.hasVAT_Italians);

        if (this.hasVAT_Italians.getValue() == 'yes') {

            this.animateInput(this.VATNumber_Italians.inputNode);

            this.UiModder.domClass.remove(this.ifVATNumberItalian, "w3-hide");
            this.VATNumber_Italians.setMandatory(true);
        } else {
            this.UiModder.domClass.add(this.ifVATNumberItalian, "w3-hide");
            this.VATNumber_Italians.setMandatory(false);
        }

    }

    _onChange_VATNumber_Italians(): void {
        this.addValue(this.VATNumber_Italians);

    }

    _onChange_socialSecurityExemption_Foreigners(): void {
        this.addValue(this.socialSecurityExemption_Foreigners);

        // Reminder PopUp
        if (this.socialSecurityExemption_Foreigners.getValue() == 'yes') {

            this.UiModder.domClass.remove(this.reminder_socialSec, "w3-hide");

            if (this.dlg != null) {
                this.dlg.destroy();
                this.dlg = null;
            }

            this.dlg = new GenericDialog();
            this.dlg.set("header", window.translations['PersonData__ReminderPopUp_title']);
            this.dlg.textNode.innerHTML = window.translations['PersonData__PopUpReminder'];
            this.dlg.set("closeBtn", true);
            this.dlg.open();



        } else {
            this.UiModder.domClass.add(this.reminder_socialSec, "w3-hide");
        }


    }

    onChange_fiscalTaxCode(): void {
        this.addValue(this.fiscalTaxCode);

    }

    _onChange_hasUidNumber_Foreigners(): void {
        this.addValue(this.hasUidNumber_Foreigners);

        if (this.hasUidNumber_Foreigners.getValue() == "yes") {
            this.VATNumber_Foreigners.setMandatory(true);
            this.UiModder.domClass.remove(this.Edit_VATNumber_Foreigners, "w3-hide");
        } else {
            this.VATNumber_Foreigners.setMandatory(false);
            this.UiModder.domClass.add(this.Edit_VATNumber_Foreigners, "w3-hide");
        }
    }

    onChange_VATNumber_Foreigners(): void {
        this.addValue(this.VATNumber_Foreigners);

    }

    _onChange_hasResidencePermit(): void {
        this.addValue(this.hasResidencePermit);


        if (this.hasResidencePermit.getValue() == "yes") {

            // Styling
            this.animateInput(this.reasonOfStay_residencePermit.inputNode);
            this.animateInput(this.issuedBy_residencePermit.inputNode);


            this.UiModder.domClass.remove(this.ifHaveResidencePermit, "w3-hide");
            this.number_residencePermit.setMandatory(true);
            this.validUntil_residencePermit.setMandatory(true);
            this.reasonOfStay_residencePermit.setMandatory(true);
            this.issuedBy_residencePermit.setMandatory(true);
        } else {
            this.UiModder.domClass.add(this.ifHaveResidencePermit, "w3-hide");
            this.number_residencePermit.setMandatory(false);
            this.validUntil_residencePermit.setMandatory(false);
            this.reasonOfStay_residencePermit.setMandatory(false);
            this.issuedBy_residencePermit.setMandatory(false);
        }
    }

    _onChange_number_residencePermit(): void {
        this.addValue(this.number_residencePermit);

    }

    _onChange_validUntil_residencePermit(): void {
        this.addDateValue(this.validUntil_residencePermit);
    }

    _onChange_reasonOfStay_residencePermit(): void {
        this.addValue(this.reasonOfStay_residencePermit);

    }

    _onChange_issuedBy_residencePermit(): void {
        this.addValue(this.issuedBy_residencePermit);

    }

    _onChange_hasVisa(): void {
        this.addValue(this.hasVisa);


        if (this.hasVisa.getValue() == "yes") {
            this.animateInput(this.issuedBy_Visa.inputNode);
            this.UiModder.domClass.remove(this.ifHaveVisa, "w3-hide");
            this.validPeriod_Visa_from.setMandatory(true);
            this.validPeriod_Visa_until.setMandatory(true);
            this.enteringItaly.setMandatory(true);
            this.leavingItaly.setMandatory(true);
            this.issuedBy_Visa.setMandatory(true);
        } else {
            this.UiModder.domClass.add(this.ifHaveVisa, "w3-hide");
            this.validPeriod_Visa_from.setMandatory(false);
            this.validPeriod_Visa_until.setMandatory(false);
            this.enteringItaly.setMandatory(false);
            this.leavingItaly.setMandatory(false);
            this.issuedBy_Visa.setMandatory(false);
        }
    }

    _onChange_validPeriod_Visa_from(): void {
        this.addDateValue(this.validPeriod_Visa_from);

    }

    _onChange_validPeriod_Visa_until(): void {
        this.addDateValue(this.validPeriod_Visa_until);

    }

    _onChange_enteringItaly(): void {
        this.addDateValue(this.enteringItaly);

    }

    _onChange_leavingItaly(): void {
        this.addDateValue(this.leavingItaly);

    }

    _onChange_issuedBy_Visa(): void {
        this.addValue(this.issuedBy_Visa);

    }

    _onUploadFile(): void {


        this.addValue(this.documents_upload as any);
    }

    _onClick_Submit_Button(): void {
        console.log('FORMDATA:', this.allValues);

        //console.log('FORMDATA COMLETE:', this.dataCompletnessCheck());

        //console.log(this.documents_upload.getValue());


        if (this.dataCompletnessCheck()) {
            let text: string = "<b>" + this.translations["PersonalData__YourData"] + ":<b><br><br><br>"

            for (let property in this.allValues) {
                let strValue: string;

                switch (property) {


                    case "language":
                        text += this.translations["PersonalData__Language"] + ": " + this.allValues[property] + "<br><br>"
                        break;
                    case "ZIP_residence":
                        if (typeof (this.allValues["ZIP_residence"]) == "object") {
                            text += this[property].getLabel() + "(" + this.translations['PersonData__place_of_residence'] + "): " + this.allValues[property]["postal_code"] + "<br><br>";
                        } else if (typeof (this.allValues["ZIP_residence"]) == "string") {
                            text += this[property].getLabel() + "(" + this.translations['PersonData__place_of_residence'] + "): " + this.allValues[property] + "<br><br>"
                        }
                        break;
                    case "ZIP_domicile":
                        if (typeof (this.allValues["ZIP_domicile"]) == "object") {
                            text += this[property].getLabel() + "(" + this.translations['PersonData__place_of_domicile'] + "): " + this.allValues[property]["postal_code"] + "<br><br>";
                        } else if (typeof (this.allValues["ZIP_domicile"]) == "string") {
                            text += this[property].getLabel() + "(" + this.translations['PersonData__place_of_domicile'] + "): " + this.allValues[property] + "<br><br>"
                        }
                        break;
                    case "city_domicile":
                        if (typeof (this.allValues["city_domicile"]) == "object") {
                            text += this[property].getLabel() + "(" + this.translations['PersonData__place_of_domicile'] + "): " + this.allValues[property]["city"] + "<br><br>";

                        } else if (typeof (this.allValues["city_domicile"]) == "string") {
                            text += this[property].getLabel() + "(" + this.translations['PersonData__place_of_domicile'] + "): " + this.allValues[property] + "<br><br>"
                        }
                        break;
                    case "city_residence":
                        if (typeof (this.allValues["city_residence"]) == "object") {
                            text += this[property].getLabel() + "(" + this.translations['PersonData__place_of_residence'] + "): " + this.allValues[property]["city"] + "<br><br>";

                        } else if (typeof (this.allValues["city_residence"]) == "string") {
                            text += this[property].getLabel() + "(" + this.translations['PersonData__place_of_residence'] + "): " + this.allValues[property] + "<br><br>"
                        }
                        break;
                    case "birthPlace":
                        if (typeof (this.allValues["birthPlace"]) == "object") {
                            text += this[property].getLabel() + ": " + this.allValues[property]["city"] + "<br><br>";

                        } else if (typeof (this.allValues["birthPlace"]) == "string") {
                            text += this[property].getLabel() + ": " + this.allValues[property] + "<br><br>"
                        }
                        break;
                    case "province_domicile":
                        if (typeof (this.allValues["province_domicile"]) == "object") {
                            text += this[property].getLabel() + "(" + this.translations['PersonData__place_of_domicile'] + "): " + this.allValues[property]["description"] + "<br><br>";

                        } else if (typeof (this.allValues["province_domicile"]) == "string") {
                            text += this[property].getLabel() + ": " + this.allValues[property] + "<br><br>"
                        }
                        break;
                    case "province_residence":
                        if (typeof (this.allValues["province_residence"]) == "object") {
                            text += this[property].getLabel() + "(" + this.translations['PersonData__place_of_residence'] + "): " + this.allValues[property]["description"] + "<br><br>";

                        } else if (typeof (this.allValues["province_residence"]) == "string") {
                            text += this[property].getLabel() + ": " + this.allValues[property] + "<br><br>"
                        }
                        break;
                    case "documents_upload":
                        text += "Documents: "
                        let filenames: Array<string> = this.documents_upload.getUploadedFilenames();
                        for (let i = 0; i < filenames.length; i++) {
                            if (i == filenames.length - 1) {
                                text += filenames[i] + ".";
                            } else {
                                text += filenames[i] + ", ";
                            }
                        }
                        text += "<br>"
                        break;
                    case "birthDate":
                        strValue = this.allValues[property];

                        //2021-03-15T10:00:00
                        var sYear: string = strValue.slice(0, 4);
                        var sMonth: string = strValue.slice(5, 7);
                        var sDay: string = strValue.slice(8, 10);

                        strValue = `${sDay}.${sMonth}.${sYear}`;

                        text += this[property].getLabel() + ": " + strValue + "<br><br>"
                        break;
                    case "domicileAddress_isResidenceAddress":
                        strValue = this.allValues[property];

                        if (strValue == "yes") strValue = this.translations["PersonData__yes"];
                        if (strValue == "no") strValue = this.translations["PersonData__no"];

                        text += this[property].getLabel() + ": " + strValue + "<br><br>"
                        break;
                    case "hasItalianFiscalCode":
                        strValue = this.allValues[property];

                        if (strValue == "yes") strValue = this.translations["PersonData__yes"];
                        if (strValue == "no") strValue = this.translations["PersonData__no"];

                        text += this[property].getLabel() + ": " + strValue + "<br><br>"
                        break;
                    case "hasVAT_Italians":
                        strValue = this.allValues[property];

                        if (strValue == "yes") strValue = this.translations["PersonData__yes"];
                        if (strValue == "no") strValue = this.translations["PersonData__no"];

                        text += this[property].getLabel() + ": " + strValue + "<br><br>"
                        break;
                    case "socialSecurityExemption_Foreigners":
                        strValue = this.allValues[property];

                        if (strValue == "yes") strValue = this.translations["PersonData__yes"];
                        if (strValue == "no") strValue = this.translations["PersonData__no"];

                        text += this[property].getLabel() + ": " + strValue + "<br><br>"
                        break;

                    case "hasResidencePermit":
                        strValue = this.allValues[property];

                        if (strValue == "yes") strValue = this.translations["PersonData__yes"];
                        if (strValue == "no") strValue = this.translations["PersonData__no"];

                        text += this[property].getLabel() + ": " + strValue + "<br><br>"
                        break;
                    case "hasVisa":
                        strValue = this.allValues[property];

                        if (strValue == "yes") strValue = this.translations["PersonData__yes"];
                        if (strValue == "no") strValue = this.translations["PersonData__no"];

                        text += this[property].getLabel() + ": " + strValue + "<br><br>"
                        break;

                    case "hasUidNumber_Foreigners":
                        strValue = this.allValues[property];

                        if (strValue == "yes") strValue = this.translations["PersonData__yes"];
                        if (strValue == "no") strValue = this.translations["PersonData__no"];

                        text += this[property].getLabel() + ": " + strValue + "<br><br>"
                        break;

                    default:
                        text += this[property].getLabel() + ": " + this.allValues[property] + "<br><br>"
                }

            }

            if (this.dlg != null) {
                this.dlg.destroy();
                this.dlg = null;
            }

            this.dlg = new GenericDialog();
            this.dlg.set("header", this.translations["PersonData__checkYourData_header"]);
            this.dlg.textNode.innerHTML = text;
            this.dlg.setUserdefinedButton(this.translations["PersonData__checkYourData_send"], "", lang.hitch(this, function () { this.sendData(this.allValues); }), true);
            this.dlg.set("BackBtn", true);
            this.dlg.open();

        }

    }

    hideEverything(): void {
        this.UiModder.domClass.add(this.domNode, "w3-hide");

        window.removeEventListener("beforeunload", this.beforeOnloadEventFunction);

        window.history.back();
    }

    // Events ----------------------------------------- END
    dummyData: any = {
        BIC_SWIFT: "Dd5dDFGd5", VATNumber_Foreigners: "555555555555555555f", ZIP_domicile: "55fssdsdf", ZIP_residence: "111", bankAccNumber: "123 5555 555", bankAddress: "jkljkljkl", bankName: "hhh",
        birthCountry: "jm", birthDate: "2020-08-03T02:00:00", citizenship: "am", city_domicile: "somef", city_residence: "sdf", country_domicile: "ai", country_residence: "it", domicileAddress_isResidenceAddress: "no",
        email: "dfg@dfg.dfg", firstName: "aaa", fiscalTaxCode: "444444444444444444444", gender: "male", hasItalianFiscalCode: "no", hasResidencePermit: "no", hasVisa: "no", language: "de", phone: "+436464666",
        routingNumber: "786978979", socialSecurityExemption_Foreigners: "no", streetNumber_domicile: "fgh 55", streetNumber_residence: "asd123", surname: "bbb"
    };

    // province hintBoxes nur wenn country == 'it' -------START
    showProvinceInput(input: MdsLax<InstanceType<typeof _StatefulBase>>) {
        this.UiModder.domClass.remove(input.domNode, "w3-hide");
        input.setMandatory(true);
    }

    hideProvinceInput(input: MdsLax<InstanceType<typeof _StatefulBase>>) {
        this.UiModder.domClass.add(input.domNode, "w3-hide");
        input.setMandatory(false);
    }

    // province hintBoxes nur wenn country == 'it' -------END

    // Privacy checkbox -----------------------------START

    _onValueChange_privacyCheckBox(): void {

        this.privacyChecked = this.privacyCheckBox.getValue();
        console.log("privacy valuechange ", this.privacyChecked);

    }

    _onClick_privacyLink(): void {

        if (this.dlg != null) {
            this.dlg.destroy();
            this.dlg = null;
        }

        this.dlg = new GenericDialog();

        let contentHeader: string = this.translations["Impressum__Datenschutz_Header"];
        let contentText: string = this.translations["Impressum__Datenschutz_Content"];

        this.dlg.set("header", this.translations["PersonData__privacy_DialogHeader"]);


        this.dlg.textNode.innerHTML = "<h3>" + contentHeader + "</h3>" + "<br><br>" + contentText + " <br>";
        this.dlg.set("closeBtn", true);
        this.dlg.open();
    }

    // Privacy checkbox -----------------------------END

    setValues(data: object): void {

        if (typeof data === 'object' && JSON.stringify(data) !== '{}') {

            this.allValues = data;

            for (let input in data) {

                if (input == 'language') {
                    continue;
                }

                this[input].setValue(data[input]);

            }
        }

    }

    // check if all the data has been submited
    dataCompletnessCheck(): boolean {

        let result = true;

        let mandatoryKeys = this.mandataoryFields;

        this.allValues['hasItalianFiscalCode'] == 'yes' && mandatoryKeys.push('italianFiscalCode');
        //this.allValues['birthCountry'] == 'it' && mandatoryKeys.push('birthPlace');
        this.allValues['country_residence'] == 'it' && mandatoryKeys.push('province_residence');


        if (this.allValues['domicileAddress_isResidenceAddress'] === 'no') {
            mandatoryKeys = mandatoryKeys.concat(this.fields_domicile_residence_address);
        }

        if (this.isItalianCitizen) {
            mandatoryKeys = mandatoryKeys.concat(this.fields_ItalianCitizen);
            if (this.allValues['hasVAT_Italians'] === 'yes') {
                mandatoryKeys.push('VATNumber_Italians')
            } else {
                let index: number;
                for (let key in mandatoryKeys) {
                    index = mandatoryKeys.indexOf("VATNumber_Italians");
                    mandatoryKeys.splice(index, 1);
                }
            }
            if (this.allValues['domicileAddress_isResidenceAddress'] === 'no' && this.allValues['country_domicile'] == 'it') mandatoryKeys.push('province_domicile');
        } else {
            mandatoryKeys = mandatoryKeys.concat(this.fields_notItalianCitizen);
            if (this.allValues["hasUidNumber_Foreigners"] == "yes") mandatoryKeys.push("VATNumber_Foreigners");
        }

        if (!this.isEuCitizen) {
            mandatoryKeys = mandatoryKeys.concat(this.fields_notEuCitizen);
            if (this.allValues['hasResidencePermit'] === 'yes') mandatoryKeys = mandatoryKeys.concat(this.fields_hasResidencePermit);
            if (this.allValues['hasVisa'] === 'yes') mandatoryKeys = mandatoryKeys.concat(this.fields_hasVisa);
        }

        let text: string = "";

        for (let i = 0; i < mandatoryKeys.length; i++) {

            this[mandatoryKeys[i]].validateInput();

            if (!this.allValues.hasOwnProperty(mandatoryKeys[i])) {
                result = false
                //console.log("missing property: ", mandatoryKeys[i]);
                text += this[mandatoryKeys[i]].getLabel() + "<br>";
            }

            //if (mandatoryKeys[i] == "documents_upload" && this.allValues.hasOwnProperty('documents_upload')) { // doc upload soll jetzt nicht mehr obligatorisch sein
            //    if (this.allValues["documents_upload"].length == 0) {
            //        result = false
            //        console.log("missing property: ", mandatoryKeys[i]);
            //        text += this[mandatoryKeys[i]].getLabel() + "<br>";
            //    }
            //}
        }

        if (this.privacyChecked === false) {

            this.privacyCheckBox.validateInput();
            result = false
            text += this.translations["PersonData__privacy_please_confirm"] + "<br>";
        }

        if (result === false) {
            if (this.dlg != null) {
                this.dlg.destroy();
                this.dlg = null;
            }

            this.dlg = new GenericDialog();
            this.dlg.set("header", "ICNOMPLETE DATA");
            this.dlg.textNode.innerHTML = window.translations["PersonData__incompletData"] + "<br><br> <b>" + window.translations["PersonalData__obligatoryFields"] + ": </b> <br>" + text;
            this.dlg.set("closeBtn", true);
            this.dlg.open();
        }

        return result;
    }

    // Add/delete Input values to/in this.allValues bei inputNode._onValueChange Event von jedem Input
    addValue(input: MdsLax<InstanceType<typeof _StatefulBase>>): void {
        if (input.getValue() && input.validateInput()) {

            let widgetName: string = this.getAttachPointNameForWidget(input);
            let widgetValue: any = input.getValue();

            if (this.caseEditingFields.indexOf(widgetName) != -1 && typeof widgetValue == 'string') {
                widgetValue = this._editCaseCamel(widgetValue);
            }

            this.allValues[widgetName] = widgetValue;
        } else {
            delete this.allValues[this.getAttachPointNameForWidget(input)];
        }

    }
    // ... Das gleiche ^^^ für Dates, um den string im Format YYYY-MM-DDTHH:mm:ss zu bekommen
    addDateValue(input: MdsLax<InstanceType<typeof DateInput>>): void {

        if (input.validateInput()) {
            this.allValues[this.getAttachPointNameForWidget(input)] = input.toStringISO(input.getValue());
        } else {
            delete this.allValues[this.getAttachPointNameForWidget(input)];
        }

    }

    getAttachPointNameForWidget(widget: MdsLax<InstanceType<typeof _StatefulBase>>): string {
        for (let attachPointName of this._attachPoints) {
            if (this[attachPointName] == widget) {
                return attachPointName;
            }
        }
    }

    // Preferred counries vorne in AllCountriesData platzieren, damit sie im SelectBox oben angezeigt werden
    addPreferredCountries(): void {

        for (let i = 0; i < this.preferredCountries.length; i++) {
            let countryName: string = this.preferredCountries[i];
            for (let i = 0; i < this.AllCountriesData.length; i++) {

                if (this.AllCountriesData[i].iso2 == countryName) {
                    this.topCountries.push(this.AllCountriesData[i]);
                }
            }
        }

        //countries.unshift(...topCountries);
    }

    populateCountrySelect(node: MdsLax<InstanceType<typeof SelectBox>>): void {

        for (var i = 0; i < this.topCountries.length; i++) {
            let country = this.topCountries[i];
            node.addEntry(country.iso2, country.name, true);
        }

        node.addEntry("", "&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473", false);

        for (var i = 0; i < this.AllCountriesData.length; i++) {
            let country = this.AllCountriesData[i];
            node.addEntry(country.iso2, country.name, true);
        }



        node.on("valueChange", function (value) { });
        node.setPlaceholder(this.translations["PersonData__SelectBox_pleaseChoose"]);


        // (!) languages are not always corresponding to iso2 country codes
        //let brLanguage = navigator.language.slice(-2).toLowerCase()

        //setDefault Value -- (!)auch da wo man s nicht braucht
        //node.setValue("it", true);

        node.startup();

    }

    //

    changeLanguage(): void {

        let urlParam: string = this.language.getValue() as string;

        this.setUrlParameter("lang", urlParam);
        location.reload();
    }

    setLanguageSelect(): void {


        this.selectedLanguage = this.getUrlParameterValue("lang");

        if (this.selectedLanguage) {
            this.language.setValue(this.selectedLanguage, true);
            this.language.validateInput();
            this.allValues[this.getAttachPointNameForWidget(this.language)] = this.language.getValue();
        }
    }

    // display document warning tabs
    displayTab(node: HTMLElement, tabName: string): void {
        let i;
        let elements = node.getElementsByClassName("tabs");

        for (i = 0; i < elements.length; i++) {
            this.UiModder.domClass.contains(elements[i], tabName) ?
                this.UiModder.domAttr.set(elements[i], "style", "display:block") :
                this.UiModder.domAttr.set(elements[i], "style", "display:none");

        }
    }

    // Request --------------------------------------------------- START

    sendData(data: object): void {

        let requestUrl: string = null;

        if (this.controllerUrl) {
            requestUrl = window.appRoot + this.controllerUrl;
        } else {
            console.log('Controller Url for Personal Data Form is NULL!')
            return;
        }

        console.log(" UNCOMMENT FOR PROD !!! Data sent::", data);
        alert("Data wasn't sent because this is just a Demo application")

        //let requestParams = {
        //    "jsonData": JSON.stringify(data)
        //};

        //this.__request = this.RequestManager.post(
        //    requestUrl,
        //    requestParams,
        //    lang.hitch(this, this._onSendDataResponse),
        //    lang.hitch(this, this._onSendDataError)
        //);
    }

    // Response optional for DEVELOPMENT
    _onSendDataResponse(response?: object): void {

        if (typeof response == "object" && response["Message"] && response["Message"] != "success") {
            alert(response["Message"]);
        } else if (response["Message"] && response["Message"] == "success") {
            if (this.dlg != null) {
                this.dlg.destroy();
                this.dlg = null;
            }

            this.dlg = new GenericDialog();
            this.dlg.set("header", window.translations['PersonData__ReminderPopUp_title']);
            this.dlg.textNode.innerHTML = window.translations['PersonData__dataSentSuccessfully'];
            this.dlg.set("closeBtn", true);
            this.dlg.on("close", lang.hitch(this, "hideEverything"));
            this.dlg.open();
        } else {
            alert("something went wrong, please refere to the console.");
            console.log("SEND DATA RESPONSE: ", response);
        }
    }

    _onSendDataError(err: object): void {

        if (typeof err == "object" && err["Message"] && err["Message"] != "success") {
            alert(err["Message"]);
        } else if (err["Message"] && err["Message"] == "success") {
            if (this.dlg != null) {
                this.dlg.destroy();
                this.dlg = null;
            }

            this.dlg = new GenericDialog();
            this.dlg.set("header", window.translations['PersonData__success']);
            this.dlg.textNode.innerHTML = window.translations['PersonData__dataSentSuccessfully'];
            this.dlg.set("closeBtn", true);
            this.dlg.on("closed", lang.hitch(this, "hideEverything"));
            this.dlg.open();

        } else {
            alert("something went wrong, please refere to the console.");
            console.log("SEND DATA ERROR: ", err);
        }
    }


    // Request ----------------------------------------------------END
    // File Upload -----------------------------------------------START


    // fileupload ------------------------------------------------END
    // erstes Zeichen groß andere klein
    _editCaseCamel(value: string, eachWord: boolean = true): string {

        value = value.trim();

        if (value.length != 17 && value.indexOf(":") != 8) { // wenn das keine id ist
            let words: Array<string> = value.split(" ");
            let camelCasedWords: Array<string> = [];
            if (words && words.length && eachWord === true) {
                for (let word of words) {
                    let lowerCale: string = word.slice(1).toLowerCase();
                    let firstCase: string = word.slice(0, 1).toUpperCase();
                    camelCasedWords.push(firstCase + lowerCale);
                }

                return camelCasedWords.join(" ");
            } else {
                let lowerCale: string = value.slice(1).toLowerCase();
                let firstCase: string = value.slice(0, 1).toUpperCase();

                return firstCase + lowerCale;
            }
        } else {
            // sont unmodifiziert zurück geben
            return value;
        }
    }


    // Styling ---------------------------------------------------START
    animateInput(node: HTMLInputElement): void {
        if (screen.width > 600) {
            this.UiModder.domClass.add(node, "w3-animate-input");
            this.UiModder.domStyle.set(node, "width", "48.5%");
        } else {
            this.UiModder.domClass.remove(node, "w3-animate-input");
            this.UiModder.domStyle.set(node, "width", "100%");
        }
    }

    // Styling ---------------------------------------------------END


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        ExtraHelpers.sideLoadResource(
                            window.appRoot + "Content/intertelinput/intlTelInput.js", 'js'
                ).then(()=>{
                    let defaults: Array<string> = window.intlTelInputGlobals.defaults.preferredCountries; // ["it", "at", "be", "de", "ch", "es", "fr" , "lu", "nl", "gb"] // Content/intertelinput/intlTelInput.js
                    for (let d of defaults){
                        this.preferredCountries.unshift(d);
                    }
                    this.postCreate_continue();
        });
    }

    private postCreate_continue(){
        // daten in liste initalisieren
        //
        this.VATNumber_Italians.validationErrorMsgText = window.translations["PersonData__validationErrMsg_VAT"];

        let label: string = this.translations["PersonData__privacy_CheckboxLabel_beforeLink"] +
            " <span style='text-decoration: underline; cursor: pointer;'>" + this.translations["PersonData__privacy_CheckboxLabel_link"] + "</span> " +
            this.translations["PersonData__privacy_CheckboxLabel_afterLink"];

        this.privacyCheckBox.setLabel(label);
        on(this.privacyCheckBox["labelNodeRight"], "click", lang.hitch(this, "_onClick_privacyLink"));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        ExtraHelpers.sideLoadResource(
            window.appRoot + "Content/intertelinput/intlTelInput.js", 'js'
        ).then(() => {
            this.phone.setPlaceholderNumberType("FIXED_LINE");

            this.AllCountriesData = window.intlTelInputGlobals.getCountryData();
            this.addPreferredCountries();
            this.populateCountrySelect(this.birthCountry);
            this.populateCountrySelect(this.citizenship);
            this.populateCountrySelect(this.country_residence);
            this.populateCountrySelect(this.country_domicile);
            this.hideProvinceInput(this.province_residence);
            this.hideProvinceInput(this.province_domicile);

            //this.setValues(this.dummyData);

            this.setLanguageSelect();
            this.documents_upload.showCustomSelectButton(true);
            this.documents_upload.setInputButtonLabel(window.translations['PersonalData__selectFile']);
        });
    }
}

export default mdsWidget(PersonalDataForm);
